// src/api/addDataArchive.js
import jwtAxios from '@crema/services/auth/jwt-auth';
import {handleError} from './handleError';

/**
 * Fetch data for Add Data Archive with pagination and filters
 * @param {number} page - The current page number (zero-based)
 * @param {object} filters - The filter parameters
 * @param {string} filters.dropdown1 - Value for Dropdown 1
 * @param {string} filters.dropdown2 - Value for Dropdown 2
 * @param {[Date, Date]} filters.dateRange - Start and end dates
 * @param {number} pageSize - Number of rows per page
 * @returns {Promise<{ data: array, count: number }>}
 */
export const getAddDataArchive = async (page, filters, pageSize = 100) => {
  const {dropdown1, dropdown2, dateRange} = filters;
  let fromDate;
  let toDate;
  
  if (dateRange && dateRange[0]) {
    const date = dateRange[0] instanceof Date ? dateRange[0] : new Date(dateRange[0]);
    if (!isNaN(date.getTime())) {
      fromDate = date.toISOString();
    }
  }
  
  if (dateRange && dateRange[1]) {
    const date = dateRange[1] instanceof Date ? dateRange[1] : new Date(dateRange[1]);
    if (!isNaN(date.getTime())) {
      // Set to end of day
      date.setHours(23, 59, 59, 999);
      toDate = date.toISOString();
    }
  }

  try {
    const response = await jwtAxios.get('archive/filtered-database-archive', {
      params: {
        pageNumber: page, // Zero-based page number
        pageSize: pageSize,
        dropdown1,
        dropdown2,
        fromDate,
        toDate,
      },
    });

    const {data} = response.data;
    const {totalCount} = response.data;

    return {data, count: totalCount};
  } catch (error) {
    return handleError(error);
  }
};
